<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 mb-3 v-if="document_type === 'select'">
          <h1 class="max">{{i18n('Escolha o tipo de pessoa')}}</h1>
        </v-flex>
        <v-flex xs12 v-if="document_type === 'select'">
          <v-container grid-list-lg>
            <v-layout row wrap justify-center dashboard-layout>
              <v-flex xs12 sm6 md4 lg3>
                <v-card ripple style="height: 100%; cursor: pointer;" @click="setDocumentType('cpf')">
                  <v-img
                    class="red--text"
                    src="/static/cpf.svg"
                    height="200px">
                  </v-img>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 md4 lg3>
                <v-card ripple style="height: 100%; cursor: pointer;" @click="setDocumentType('cnpj')">
                  <v-img
                    class="red--text"
                    src="/static/cnpj.svg"
                    height="200px">
                  </v-img>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex xs12 mb-3 v-if="document_type !== '' && document_type !== 'select' && operation == 'create'">
          <h1 class="max">{{i18n('Criar Cadastro')}}</h1>
        </v-flex>
        <v-flex xs12 v-if="document_type !== '' && document_type !== 'select' && operation == 'create'">
          <company-form operation="create" @onCreate="onCreate" @cancelled="document_type = 'select'" :record="record" v-if="isCompany" />
          <person-form operation="create" @onCreate="onCreate" @cancelled="document_type = 'select'" :record="record" v-if="isPerson" />
        </v-flex>
        <v-flex xs12 mb-3 v-if="document_type !== '' && document_type !== 'select' && operation == 'update'">
          <h1 class="max">{{i18n('Cadastro')}}</h1>
        </v-flex>
        <v-flex xs12 v-if="document_type !== '' && document_type !== 'select' && operation == 'update'">
          <company-form operation="update" :admin="admin" @onUpdate="onUpdate" @cancelled="$router.push('/dashboard')" :record="record" v-if="isCompany" />
          <person-form operation="update" :admin="admin" @onUpdate="onUpdate" @cancelled="$router.push('/dashboard')" :record="record" :partnerPortal="true" v-if="isPerson" />
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import AdminCompanyForm from "./AdminCompanyForm"
import AdminPersonForm from "./AdminPersonForm"
import Title from "./components/Title"
import utils from "./shared/Utils"

export default {
  name: 'CreateCompanyForm',
  components: { layout: LeftBarLayout, 'company-form': AdminCompanyForm, 'person-form': AdminPersonForm, 'page-title': Title },
  data: () => {
    return {
      document_type: '',
      operation: 'create',
      admin: false,
      record: {
        references: [],
        documents: []
      }
    }
  },
  mounted () {
    this.$root.authenticationStore.redirectIfNotAuthenticated()
    
    this.admin = this.$cookies.isKey('admin') && this.$cookies.get('admin') === 'true'

    this.$root.store.getCompany((company)=>{
      if (company) {
        this.operation = 'update'
        this.record = company
        this.document_type = company.document_type
      } else {
        this.operation = 'create'
        this.document_type = 'select'
        this.record.email = this.$cookies.get('email')
      }
    }, (error)=>{
    })
  },
  computed: {
    url() {
      return this.$root.urls.companies
    },
    isPerson() {
      return utils.personDocumentTypes.includes(this.document_type.toLowerCase())
    },
    isCompany() {
      return utils.companyDocumentTypes.includes(this.document_type.toLowerCase())
    }
  },
  watch: {
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    onUpdate() {
      this.$router.push('/dashboard')
    },
    onCreate(created_record) {
      let expire_at = new Date((new Date).getTime() + 60*12*60000) // 12 hours
      this.$cookies.set('company_id', created_record.id, expire_at)

      this.$router.push('/dashboard')
    },
    setDocumentType(type) {
      this.$set(this.record, 'document_type', type)
      this.$set(this.record, 'document_number', '')
      this.$nextTick(() => {
        this.document_type = type
      })
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/CreateCompanyForm.vue